export default {
    Metadata: {
        Name: "Log",
        Description: "Returns the natural logarithm (base e) of a number.",
        Syntax: "Log(number)",
        Keywords: ['Math'],
        Author: "DataVoke, Inc.",
    },
    execute(ofValue, base) {
        if (base != null) {
            return Math.log(ofValue) / Math.log(base);
        }
        else {
            return Math.log(ofValue)
        }
    },
};

